import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "./Logo";
import { config } from "../lib/config";

export function TopBar({ right }) {
  return (
    <header className="sticky top-0 z-50 border-b border-[#D4AF37]/30 bg-[#FAFAF7]/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3 sm:px-8">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <Logo linkTo={null} />
          <span className="font-display text-lg font-bold leading-none text-[#4A000E] sm:text-2xl">{config.brandName}</span>
        </Link>
        <div className="flex items-center gap-3">
          {right}
          {config.websiteUrl && (
            <a
              href={config.websiteUrl}
              target="_top"
              rel="noopener"
              data-testid="nav-website-link"
              className="inline-flex min-h-[40px] shrink-0 items-center gap-1.5 rounded-full border border-[#D4AF37]/60 px-3 py-1.5 text-xs font-semibold text-[#7A0016] transition-colors hover:bg-[#F5E6BA] sm:text-sm"
            >
              <ArrowLeft className="h-3.5 w-3.5" />
              Website
            </a>
          )}
        </div>
      </div>
    </header>
  );
}
